import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { Icon } from 'front-onceforall-core';
import TooltipButton from '../TooltipButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CreateProjectButtonView = _ref => {
  let {
    color = 'cta',
    icon,
    disabled,
    tooltipMessage,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsxs(TooltipButton, {
    color: color,
    disabled: disabled,
    tooltipMessage: tooltipMessage,
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(Translate, {
      value: "project.create.button"
    }), /*#__PURE__*/_jsx(Icon, {
      icon: icon
    })]
  });
};
CreateProjectButtonView.defaultProps = {
  icon: 'arrow-right',
  disabled: false
};
CreateProjectButtonView.propTypes = {
  icon: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  tooltipMessage: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
  onClick: PropTypes.func.isRequired
};
export default CreateProjectButtonView;